import script from "./NewScheduleTemplateButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewScheduleTemplateButton.vue?vue&type=script&lang=ts&setup=true"

import "./NewScheduleTemplateButton.vue?vue&type=style&index=0&id=15903de2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15903de2"]])

export default __exports__